import React from 'react'
import { useTranslation } from 'react-i18next'

type Props = {
  value: boolean
}

function Boolean(props: Props) {
  const { value } = props  
  const { t } = useTranslation(['boolean'])

  if (value === true) {
    return (
      <span>{t('true')}</span>
    )
  }  if (value === false) {
    return (
      <span>{t('false')}</span>
    )
  } else {
    return null
  }
}

export default Boolean